import React from 'react'

function CustomHorizontalDivider({height}) {
  return (
    <div style={{height}}/>
  )
}

export default CustomHorizontalDivider